import { Box, Heading, Text, VStack } from 'native-base';
import React, { useCallback, useState } from 'react';
import { colors } from '../../../styles';
import { openUrl } from '../../../utils';
import { Button } from '../buttons';
import { CardContainer } from './CardContainer';

export interface SurveyCardProps {
  id: string;
  title: string;
  description: string;
  actionLink: string;
  actionText: string;
  onComplete: (surveyId: string) => Promise<void>;
}

export const SurveyCard: React.FC<SurveyCardProps> = ({
  id,
  title,
  description,
  actionLink,
  actionText,
  onComplete,
}) => {
  const [completing, setCompleting] = useState(false);

  const handlePress = useCallback(async () => {
    openUrl(actionLink);
    setCompleting(true);
    try {
      await onComplete(id);
    } catch (error) {
      // Survey remains visible if marking complete fails - user can retry
      console.error('Failed to mark survey as complete:', error);
    } finally {
      setCompleting(false);
    }
  }, [actionLink, id, onComplete]);

  return (
    <CardContainer backgroundColor={colors.primaryLight}>
      <Box borderColor={colors.secondary} borderLeftWidth={4} pl={4}>
        <VStack space={3}>
          <Heading size="sm" color={colors.black}>
            {title}
          </Heading>
          <Text fontSize={14} color={colors.darkGrey}>
            {description}
          </Text>
          <Box>
            <Button
              text={actionText}
              color="secondary"
              onPress={handlePress}
              loading={completing}
            />
          </Box>
        </VStack>
      </Box>
    </CardContainer>
  );
};
